import { FunctionComponent } from 'preact';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { trackClick } from '~src/utils/tracking';
import { AcceptSubPage } from '../types/state';
import { setAcceptSubPage } from '~src/domains/accept/state/acceptReducer';
import * as styles from '~src/styles/domains/accept/components/ChangePaymentPlan.module.scss';

const ChangePaymentPlan: FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onClickAccept = () => {
    dispatch(trackClick('change-payment-plan'));
    dispatch(setAcceptSubPage(AcceptSubPage.OFFERS));
  };

  console.log(styles);

  return (
    <div className={styles['new-plan-info-wrap']} id='change-payment-plan'>
      <div className={styles['new-plan-info']}>
        <div className={styles['offer-card-amount-container']}>
          <span className={styles['header-text']}>
            {t('accept:splitOfferSelector.changePaymentPlan.paymentPlan')}
          </span>
          <button
            type='button'
            className={styles['change-plan-button']}
            onClick={onClickAccept}
          >
            <span>
              {t('accept:splitOfferSelector.changePaymentPlan.change')}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePaymentPlan;
